import getApiUrl from "../helpers/getApiUrl";

const fetchBidInfo = async (
  url: string,
  isToUseAuthZero = false,
  accessToken?: string
) => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (
    !isToUseAuthZero &&
    process.env.ENVIRONMENT === "localhost" &&
    process.env.token
  ) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const res = await fetch(getApiUrl(url, isToUseAuthZero), {
    method: "GET",
    headers,
  });

  if (res.status > 200) {
    throw `${res.status} Bidding info call failed`;
  }

  const response = await res.json();
  return response;
};

export default fetchBidInfo;
